module.exports = __webpack_public_path__ + "img/case_bottom_005.743e8c8f.png";